export const DISCONNECTED = 'disconnected';
export const CONNECTING = 'connecting';
export const CONNECTED = 'connected';
export const DISCONNECTING = 'disconnecting';
export const WIFI_MANUALLY_DISCONNECTED = 'wifi_manually_disconnected';
export const LOW_BATTERY = 'lowBattery';
export const POWERBLOW_SETTINGS = 'powerblow_settings';
export const DELETE_DEVICE = 'delete_device';
